import { Title } from 'components/common';
import React from 'react';

export default function Help() {
  return (
    <>
      <Title>이용안내</Title>
    </>
  );
}
